// extracted by mini-css-extract-plugin
module.exports = {"panel":"_2y6HQ"};